let variable_formula = Object.freeze({
    list: [
        {value: 1, text: 'Numerico'},
        {value: 2, text: 'Alfanumerico'},
        {value: 3, text: 'Logico'},
        {value: 4, text: 'Fecha'},
    ]
  });
  
  module.exports = { variable_formula }